"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CMYK = exports.HSV = exports.HSL = exports.RGB = exports.GREY = void 0;

/**
 * Color model of an image
 * @typedef {('GREY'|'RGB'|'HSL'|'HSV'|'CMYK')} ColorModel
 */
const GREY = 'GREY';
exports.GREY = GREY;
const RGB = 'RGB';
exports.RGB = RGB;
const HSL = 'HSL';
exports.HSL = HSL;
const HSV = 'HSV';
exports.HSV = HSV;
const CMYK = 'CMYK';
exports.CMYK = CMYK;